export default __webpack_public_path__ + "static/media/MY_TRACKER_ICON_5.fbe16a9f.svg";